// frontend/src/components/ListControls.js
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Button } from './ui/button';
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Shared sort + filter row for coach/admin list pages (mirrors the Coach Hub controls).
// Purely presentational — parent owns state and applies the filtering.
export default function ListControls({
  sortBy, sortDir, onSortByChange, onSortDirChange,
  filter, onFilterChange, sortOptions, filterOptions,
  children,
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col sm:flex-row gap-2">
      <Select value={sortBy} onValueChange={onSortByChange}>
        <SelectTrigger className="w-full sm:w-[170px]" data-testid="list-sort-select">
          <ArrowUpDown className="h-3.5 w-3.5 mr-1" /> <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {sortOptions.map(o => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
        </SelectContent>
      </Select>
      <Button
        variant="outline"
        size="icon"
        onClick={() => onSortDirChange(sortDir === 'asc' ? 'desc' : 'asc')}
        title={sortDir === 'asc' ? t('common.sortAsc', 'Ascending') : t('common.sortDesc', 'Descending')}
        aria-label={t('common.toggleSortDirection', 'Toggle sort direction')}
        data-testid="list-sort-direction"
      >
        {sortDir === 'asc' ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />}
      </Button>
      <Select value={filter} onValueChange={onFilterChange}>
        <SelectTrigger className="w-full sm:w-[180px]" data-testid="list-filter-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {filterOptions.map(o => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
        </SelectContent>
      </Select>
      {children}
    </div>
  );
}
